/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import AddIcon from "@mui/icons-material/Add";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import {
    Avatar,
    Checkbox,
    Chip,
    Collapse,
    Divider,
    Grid2,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemIcon,
    ListItemText,
    Popover,
    TextField,
} from "@mui/material";
import classnames from "classnames";
import TextAreaEditor from "components/common/TextAreaEditor";
import { compareContactByLastName } from "core/dataConstants";
import { assertArray, assertObject, assertString } from "core/validation";
import { cloneDeep, get, uniqBy } from "lodash";
import PropTypes from "prop-types";
import randomColor from "randomcolor";
import React from "react";
import PopoverForm from "../PopoverForm";
import "./styles.scss";

export function mapContact(contact) {
    return {
        ...contact,
        name: assertObject(contact.name) ? contact.name : ` ${contact.firstName} ${contact.lastName}`,
        id: contact.id,
        phone: assertArray(contact.addresses) && (contact.addresses[0].phone1 || contact.addresses[0].phone2),
        email: assertObject(contact.email)
            ? contact.email
            : assertArray(contact.addresses) && contact.addresses[0].email,
    };
}
export const sortList = (filterOptions) => {
    return assertArray(filterOptions)
        ? filterOptions
            .sort(compareContactByLastName)
            .map((contact) => mapContact(contact))
            .sort(compareContactByLastName)
        : [];
};
export function filterContact(options, value) {
    const filterOptions = assertString(value)
        ? options.filter(
            (opt) =>
                opt.name.toLowerCase().includes(value.toLowerCase()) ||
                  (opt.phone && opt.phone.toLowerCase().includes(value.toLowerCase())) ||
                  (opt.email && opt.email.toLowerCase().includes(value.toLowerCase()))
        )
        : cloneDeep(options);
    return filterOptions;
}
export function ContactListItem({ user, avatarName, showEmailFirst, checked, showCheckboxes, onChecked }) {
    const [open, setOpen] = React.useState(true);
    const [value, setValue] = React.useState(checked);

    const backgroundColor = React.useMemo(() => {
        return randomColor();
    }, []);

    React.useEffect(() => {
        if (checked !== value) {
            setValue(checked);
        }
    }, [checked]);

    const handleClick = () => {
        setOpen(!open);
    };

    const [firstEmail, ...restEmail] = user.email ? user.email.split(";") : ["", []];

    const secondary = showEmailFirst ? firstEmail || user.phone : user.phone || firstEmail;
    function handleOnChecked() {
        setValue(!value);
        onChecked(!value, user);
    }
    const userNote = user.note ? user.note : "<p></p>";
    return (
        <React.Fragment>
            <ListItem className="contact" style={{ padding: "5px 10px" }}>
                {showCheckboxes && (
                    <ListItemIcon style={{ minWidth: 30 }}>
                        <Checkbox edge="start" checked={value} onChange={handleOnChecked} tabIndex={-1} disableRipple />
                    </ListItemIcon>
                )}
                {avatarName && (
                    <ListItemAvatar style={{ minWidth: 45 }}>
                        <Avatar style={{ width: 30, height: 30, fontSize: 16, backgroundColor }}>{avatarName}</Avatar>
                    </ListItemAvatar>
                )}
                <ListItemText primary={user.name} secondary={secondary} />
                {}
                {}
                {}
                {}
                {}
                {}
                {}
                {}
                {(user.phone || restEmail.length !== 0 || user.title || user.note) &&
                    (open ? <ExpandLess onClick={handleClick} /> : <ExpandMore onClick={handleClick} />)}
            </ListItem>
            {(user.phone || restEmail.length !== 0 || user.title || user.note) && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List
                        style={{
                            maxWidth: "500px",
                        }}
                        component="div"
                        disablePadding
                    >
                        {user.phone
                            ? [firstEmail, ...restEmail].map(
                                (email, i) =>
                                    email.length > 0 && (
                                        <ListItem
                                            key={email}
                                            style={{
                                                paddingLeft: avatarName ? 85 : 40,
                                                marginTop: i !== 0 ? -20 : 0,
                                            }}
                                            className={classnames({ "contact-additional-info": open })}
                                        >
                                            <Divider />
                                            <ListItemText primary={email} />
                                        </ListItem>
                                    )
                            )
                            : restEmail.map(
                                (email, i) =>
                                    email.length > 0 && (
                                        <ListItem
                                            key={email}
                                            style={{
                                                paddingLeft: avatarName ? 85 : 40,
                                                marginTop: i !== 0 ? -20 : -10,
                                            }}
                                            className={classnames({ "contact-additional-info": open })}
                                        >
                                            <Divider />
                                            <ListItemText primary={email} />
                                        </ListItem>
                                    )
                            )}
                        {user.title && (
                            <ListItem
                                style={{ paddingLeft: avatarName ? 85 : 40, marginTop: user.email ? -20 : -10 }}
                                className={classnames({ "contact-additional-info": open })}
                            >
                                <ListItemText primary={"Title: " + user.title} />
                            </ListItem>
                        )}
                        {user.note && (
                            <ListItem
                                style={{
                                    paddingLeft: avatarName ? 85 : 40,
                                    marginTop: user.title || user.email ? -20 : -10,
                                }}
                                className={classnames({ "contact-additional-info": open })}
                            >
                                {"Note: "}
                                <ListItemText
                                    primary={
                                        <TextAreaEditor
                                            rootStyle={{ width: "fit-content", maxWidth: "fit-content" }}
                                            styles={{
                                                maxHeight: "fit-content",
                                                height: "fit-content",
                                                minHeight: "fit-content",
                                                border: "none",
                                                marginTop: 2,
                                            }}
                                            defaultValue={userNote}
                                            readOnly={true}
                                            active={false}
                                        />
                                    }
                                />
                            </ListItem>
                        )}
                        {user.assistantPhone && user.assistant && (
                            <ListItem
                                style={{
                                    paddingLeft: avatarName ? 85 : 40,
                                    marginTop: user.title || user.email || user.note ? -20 : -10,
                                }}
                                className={classnames({ "contact-additional-info": open })}
                            >
                                <ListItemText
                                    primary={"Assistant: " + user.assistant}
                                    secondary={user.assistantPhone}
                                />
                            </ListItem>
                        )}
                    </List>
                </Collapse>
            )}
        </React.Fragment>
    );
}

export function ContactListItemForCompanyContact({
    user,
    avatarName,
    showEmailFirst,
    checked,

    onChecked,
}) {
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState(checked);

    const backgroundColor = React.useMemo(() => {
        return randomColor();
    }, []);

    React.useEffect(() => {
        if (checked !== value) {
            setValue(checked);
        }
    }, [checked]);

    const handleClick = () => {
        setOpen(!open);
    };

    const [firstEmail, ...restEmail] = user.email ? user.email.split(";") : ["", []];

    const secondary = showEmailFirst ? firstEmail || user.phone : user.phone || firstEmail;
    function handleOnChecked() {
        setValue(!value);
        onChecked(!value, user);
    }
    return (
        <React.Fragment>
            <div onClick={handleOnChecked}>
                <ListItem className="contact" style={{ padding: "5px 10px" }}>
                    {avatarName && (
                        <ListItemAvatar style={{ minWidth: 45 }}>
                            <Avatar style={{ width: 30, height: 30, fontSize: 16, backgroundColor }}>
                                {avatarName}
                            </Avatar>
                        </ListItemAvatar>
                    )}
                    <ListItemText primary={user.name} secondary={secondary} />
                    {(user.phone || restEmail.length !== 0) &&
                        (open ? <ExpandLess onClick={handleClick} /> : <ExpandMore onClick={handleClick} />)}
                </ListItem>
            </div>
            {(user.phone || restEmail.length !== 0) && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {user.phone
                            ? [firstEmail, ...restEmail].map((email, i) => (
                                <ListItem
                                    key={email}
                                    style={{ paddingLeft: avatarName ? 62 : 20 }}
                                    className={classnames({ "contact-additional-info": open })}
                                >
                                    <Divider />
                                    <ListItemText primary={email} secondary={i === restEmail.length && user.note} />
                                </ListItem>
                            ))
                            : restEmail.map((email, i) => (
                                <ListItem
                                    key={email}
                                    style={{ paddingLeft: 62 }}
                                    className={classnames({ "contact-additional-info": open })}
                                >
                                    <Divider />
                                    <ListItemText
                                        primary={email}
                                        secondary={i === restEmail.length - 1 && user.note}
                                    />
                                </ListItem>
                            ))}
                    </List>
                </Collapse>
            )}
        </React.Fragment>
    );
}

ContactListItemForCompanyContact.propTypes = {
    user: PropTypes.object.isRequired,
    avatarName: PropTypes.string,
    showEmailFirst: PropTypes.bool,
    checked: PropTypes.bool,
    onChecked: PropTypes.func,
};

export class ContactDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterOptions: sortList(props.options),
            exitPopover: false,
            valueStr: null,
            value: props.value,
        };
        this.onSelectOption = this.onSelectOption.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onExitPopover = this.onExitPopover.bind(this);
        randomColor({
            luminosity: "dark",
            count: assertArray(props.options) ? props.options.length : 0,
            alpha: 1,
        });
    }

    onEnteredPopover = () => {
        let filterOptions = [];
        if (assertArray(this.props.value)) {
            filterOptions = uniqBy([...sortList(this.props.value), ...this.state.filterOptions], (a) => a.id);
        } else {
            filterOptions = this.state.filterOptions;
        }
        this.setState({
            value: this.props.value,
            filterOptions: cloneDeep(filterOptions),
        });
    };

    onClosePopover = () => {
        if (this.props.onChange) {
            this.props.onChange(this.state.value);
        }
    };
    onExitPopover = () => {
        this.setState({ exitPopover: false });
        this.props.onChange(this.state.value);
    };

    onTextChange(event) {
        const { lazy, options } = this.props;
        const value = event.target.value;
        if (!lazy) {
            const filterOptions = filterContact(sortList(options), value);
            this.setState({
                filterOptions,
                valueStr: value,
            });
        }
    }

    onSelectOption(opt) {
        this.setState(
            {
                value: opt,
                exitPopover: !this.props.multiple,
            },
            this.onSelectCallback
        );
    }

    onSelectCallback() {
        const { multiple, onSelect } = this.props;
        if (!multiple) {
            onSelect(this.state.value);
        }
    }

    onCopyToClipboard = (id) => {
        const copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
    };

    onChangeValue = (value) => {
        this.setState({ value });
    };
    onChecked = (value, user) => {
        if (this.props.isSingle) {
            if (value) {
                this.onChangeValue([user]);
            } else {
                this.onChangeValue([]);
            }
            this.setState({ exitPopover: true });
        } else {
            if (value) {
                this.onChangeValue([...this.state.value, user]);
            } else {
                this.onChangeValue(this.state.value.filter((u) => u.id !== user.id));
            }
        }
    };

    getAvatarName = (user) =>
        user
            ? `${user.firstName ? user.firstName.substring(0, 1).toUpperCase() : ""}${
                user.lastName ? user.lastName.substring(0, 1).toUpperCase() : ""
            }`
            : "";
    renderItems = (user) => {
        const avatarname = this.getAvatarName(user);

        let checked = false;
        if (this.props.readOnly) {
            checked = false;
        } else {
            checked = assertArray(this.state.value) && this.state.value.findIndex((u) => u.id === user.id) !== -1;
        }
        return (
            <ContactListItem
                key={user.id}
                user={user}
                showEmailFirst={this.props.showEmailFirst}
                avatarName={avatarname}
                showCheckboxes={!this.props.readOnly}
                checked={checked}
                onChecked={this.onChecked}
            />
        );
    };

    componentDidUpdate(prevProps) {
        if (this.props.options.length !== prevProps.options.length) {
            this.setState({
                filterOptions: sortList(this.props.options),
            });
            randomColor({
                luminosity: "dark",
                count: this.props.options.length,
                alpha: 1,
            });
        }
    }
    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    renderContacts = () => {
        const optionsToShow = this.props.readOnly ? this.props.options : this.props.value;

        if (assertArray(optionsToShow)) {
            const opts = sortList(optionsToShow);

            const _optionsToShow = opts.length > this.props.maxOptions ? opts.slice(0, this.props.maxOptions) : opts;
            const styl = this.props.renderLabel
                ? {
                    marginTop: 15,
                    textAlign: "left",
                    marginLeft: 5,
                }
                : {};
            if (this.props.display === "column") {
                return (
                    <span style={styl}>
                        {_optionsToShow.map((opt) => {
                            return (
                                <span key={opt.value || opt.id} style={{ marginRight: 5 }}>
                                    <ContactChip user={opt} />
                                </span>
                            );
                        })}
                    </span>
                );
            }
            return (
                <div style={styl}>
                    {_optionsToShow.map((opt) => {
                        return (
                            <div key={opt.value || opt.id} style={{ marginBottom: 3 }}>
                                <ContactChip user={opt} />
                            </div>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    renderPlus = () => {
        const optionsToShow = this.props.readOnly ? this.props.options : this.props.value;
        const plus = this.props.readOnly ? null : (
            <IconButton size="small" variant="contained" color="secondary">
                <AddIcon />
            </IconButton>
        );

        if (assertArray(optionsToShow)) {
            let chip =
                optionsToShow.length > this.props.maxOptions ? (
                    <Chip
                        size={"small"}
                        variant="outlined"
                        color="black"
                        style={{ cursor: "pointer" }}
                        label={`+ ${optionsToShow.length - this.props.maxOptions} more`}
                    />
                ) : null;
            if (this.props.hideContactsPreview) {
                chip = null;
            }
            return this.props.display === "column" ? (
                <span>
                    {chip}
                    {plus}
                </span>
            ) : (
                <div>
                    {chip}
                    {plus}
                </div>
            );
        }
        if (!this.props.readOnly) {
            return this.props.display === "column" ? <span>{plus}</span> : <div>{plus}</div>;
        }
        return null;
    };

    renderInput = () => {
        const user = assertArray(this.props.value) ? this.props.value[0] : null;
        let value = "";
        if (user) {
            const contact = mapContact(user);
            const email = contact.email || "";
            value = `${contact.name} <${email}>`;
        }
        return <TextField label={null} fullWidth onChange={() => ({})} variant={"outlined"} value={value} />;
    };

    render() {
        const { valueStr, filterOptions, exitPopover } = this.state;
        const { renderItems, options, placeholder, renderLabel, isSingle, hideContactsPreview } = this.props;
        const contacts = hideContactsPreview ? null : (
            <React.Fragment>
                {renderLabel && "Contacts:"} {this.renderContacts()}
            </React.Fragment>
        );
        const _renderItems = renderItems ? renderItems : this.renderItems;
        const renderPlus = isSingle ? this.renderInput() : this.renderPlus();

        return (
            <PopoverForm
                minWidth={"fit-content"}
                exitPopover={exitPopover}
                trigger={renderPlus}
                onEnteredPopover={this.onEnteredPopover}
                beforeTrigger={contacts}
                onClosePopover={this.onClosePopover}
                onExitPopover={this.onExitPopover}
            >
                {
                    <div className={"popoverSelectC"}>
                        {
                            <TextField
                                placeholder={placeholder}
                                label={null}
                                fullWidth
                                size="medium"
                                margin="dense"
                                className={"selectTextInput"}
                                value={valueStr}
                                onChange={this.onTextChange}

                            />
                        }
                        <div className={"popoverListContainer"}>
                            {assertArray(options) ? (
                                <List component="nav" aria-label="secondary mailbox folders">
                                    {filterOptions.map((opt) => _renderItems(opt))}
                                </List>
                            ) : (
                                <div>no items</div>
                            )}
                        </div>
                    </div>
                }
            </PopoverForm>
        );
    }
}

export function ContactChip({ user, size = "small" }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const click = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const onClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const phone = get(user, "addresses[0].phone1", null);
    const email = get(user, "addresses[0].email", null);

    return (
        <React.Fragment>
            <Chip label={user.name} color="black" size={size} variant="outlined" onClick={click} icon={<ExpandMoreOutlinedIcon />} />
            <Popover
                id={user.id}
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <div className={"atsPopoverContainer"}>
                    <Grid2 container direction={"column"} spacing={2}>
                        {phone && (
                            <Grid2>
                                {}
                                <span className={"atsTitleCar"}>
                                    {phone}
                                    <span style={{ fontSize: 14 }}></span>
                                </span>
                            </Grid2>
                        )}
                        {email && (
                            <Grid2>
                                {}
                                <span className={"atsTitleCar"}>
                                    {email}
                                    <span style={{ fontSize: 14 }}></span>
                                </span>
                            </Grid2>
                        )}
                        {!email && !phone && "No information available"}
                    </Grid2>
                </div>
            </Popover>
        </React.Fragment>
    );
}

ContactDropdown.defaultProps = {
    lazy: false,
    placeholder: "Type to search",
    display: "column",
    readOnly: true,
    maxOptions: 2,
};
export default ContactDropdown;
